var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgBell = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 27.43 }, props, { children: _jsx("g", __assign({ "data-name": "Group 46" }, { children: _jsx("path", { "data-name": "Path 20", d: "M12 27.43a3.429 3.429 0 0 0 3.429-3.427H8.571A3.429 3.429 0 0 0 12 27.43Zm0-24.14-1.366.276a6.861 6.861 0 0 0-5.491 6.722 37.2 37.2 0 0 1-.787 6.415 22.176 22.176 0 0 1-1.137 3.87h17.562a22.281 22.281 0 0 1-1.137-3.87 37.2 37.2 0 0 1-.787-6.415 6.861 6.861 0 0 0-5.491-6.72L12 3.288Zm10.663 17.283A4.362 4.362 0 0 0 24 22.288H0a4.362 4.362 0 0 0 1.337-1.715c1.543-3.086 2.091-8.777 2.091-10.286a8.574 8.574 0 0 1 6.866-8.4 1.714 1.714 0 1 1 3.411 0 8.575 8.575 0 0 1 6.866 8.4c0 1.509.549 7.201 2.092 10.286Z" }) })) }))); };
export default SvgBell;
